<template>
  <password-reset-form
    @onPasswordReset="onPasswordReset($event)"
    :isPending="passwordResetPending"
    :hasFailed="passwordResetFailed"
    :hasSucceeded="passwordResetSucceeded">
  </password-reset-form>
</template>

<script>
import { mapState } from 'vuex';

import PasswordResetForm from '@/components/auth/PasswordResetForm';

export default {
  name: 'PasswordResetContainer',
  components: {
    PasswordResetForm,
  },
  computed: {
    ...mapState('auth', [
      'passwordResetPending',
      'passwordResetFailed',
      'passwordResetSucceeded',
    ]),
  },
  methods: {
    onPasswordReset(event) {
      this.$store.dispatch('auth/resetPassword', event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// PasswordResetContainer.vue?47ef438b